// extracted by mini-css-extract-plugin
export var link = "customLink-module--link--6tlZ5";